module.exports = __webpack_public_path__ + "img/bb.b9764d8f.svg";